import { render, staticRenderFns } from "./LivingOptions.vue?vue&type=template&id=3854b76e&"
import script from "./LivingOptions.vue?vue&type=script&lang=js&"
export * from "./LivingOptions.vue?vue&type=script&lang=js&"
import style0 from "./LivingOptions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports